import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getApiData as getCompanylistApi,
    getCompanyTypeApi,
} from 'services/CompanyService'
import { getApiData as getClientCompanylistApi } from 'services/ClientCompanyService'
import { getApiData as getTransportProviderlistApi } from 'services/TransportProviderService'
import { getApiData as getTransportProviderServicelistApi } from 'services/TransportProviderServicesService'

export const getCompanyTypeData = createAsyncThunk(
    'listdata/getCompanyTypeData',
    async () => {
        const response = await getCompanyTypeApi()
        const data = response.data?.results
            ?.filter((item) => item?.name !== 'Client Company')
            ?.map((item) => {
                item.label = item.name
                item.value = item.id
                return item
            })
        return data
    },
)

export const getCompanyData = createAsyncThunk(
    'listdata/getCompanyData',
    async () => {
        const response = await getCompanylistApi()
        const data = response.data?.results
            ?.filter((item) => item?.company_type?.name !== 'Client Company')
            ?.map((item) => {
                item.label = item.name
                item.value = item.id
                return item
            })
        return data
    },
)

export const getClientCompanyData = createAsyncThunk(
    'listdata/getClientCompanyData',
    async () => {
        const response = await getClientCompanylistApi()
        const data = response.data?.results?.map((item) => {
            item.label = item?.client?.name
            item.value = item?.client?.id
            return item
        })
        return data
    },
)

export const getTransportProviderData = createAsyncThunk(
    'listdata/getTransportProviderData',
    async (datas) => {
        const response = await getTransportProviderlistApi(datas)
        const data = response.data?.results?.map((item) => {
            item.label = item.name
            item.value = item.id
            return item
        })
        return data
    },
)

export const getTransportProviderServiceData = createAsyncThunk(
    'listdata/getTransportProviderServiceData',
    async (datas) => {
        const response = await getTransportProviderServicelistApi(datas)
        const data = response.data?.results?.map((item) => {
            item.label = `${item?.name} (${item?.short_code})`
            item.value = item.id
            return item
        })
        return data
    },
)

const dataSlice = createSlice({
    name: 'listdata',
    initialState: {
        companyTypeData: [],
        companyData: [],
        clientCompanyData: [],
        transportProviderData: [],
        transportProviderServiceData: [],
    },
    reducers: {
        setCompanyTypeData: (state, { payload }) => {
            state.companyTypeData = payload
        },
        setCompanyData: (state, { payload }) => {
            state.companyData = payload
        },
        setClientCompanyData: (state, { payload }) => {
            state.clientCompanyData = payload
        },
        setTransportProviderData: (state, { payload }) => {
            state.transportProviderData = payload
        },
        setTransportProviderServiceData: (state, { payload }) => {
            state.transportProviderServiceData = payload
        },
    },
    extraReducers: (builder) => {
        builder
            //company type data
            .addCase(getCompanyTypeData.pending, (state) => {
                state.loading = true
            })
            .addCase(getCompanyTypeData.fulfilled, (state, action) => {
                state.loading = false
                state.companyTypeData = action.payload
            })
            .addCase(getCompanyTypeData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

            //company data
            .addCase(getCompanyData.pending, (state) => {
                state.loading = true
            })
            .addCase(getCompanyData.fulfilled, (state, action) => {
                state.loading = false
                state.companyData = action.payload
            })
            .addCase(getCompanyData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

            //client company data
            .addCase(getClientCompanyData.pending, (state) => {
                state.loading = true
            })
            .addCase(getClientCompanyData.fulfilled, (state, action) => {
                state.loading = false
                state.clientCompanyData = action.payload
            })
            .addCase(getClientCompanyData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

            //transport provider data
            .addCase(getTransportProviderData.pending, (state) => {
                state.loading = true
            })
            .addCase(getTransportProviderData.fulfilled, (state, action) => {
                state.loading = false
                state.transportProviderData = action.payload
            })
            .addCase(getTransportProviderData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

            //transport provider service data
            .addCase(getTransportProviderServiceData.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getTransportProviderServiceData.fulfilled,
                (state, action) => {
                    state.loading = false
                    state.transportProviderServiceData = action.payload
                },
            )
            .addCase(
                getTransportProviderServiceData.rejected,
                (state, action) => {
                    state.loading = false
                    state.error = action.error.message
                },
            )
    },
})

export const {
    setCompanyTypeData,
    setCompanyData,
    setClientCompanyData,
    setTransportProviderData,
    setTransportProviderServiceData,
} = dataSlice.actions

export default dataSlice.reducer
